import { useMutation } from "@tanstack/react-query";
import { useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { KEYWORD_CACHE_KEYS } from "./keys";

import { KeywordRepository } from "@/repositories/keyword";

export const useDeleteKeyword = () => {
  const keywordRepository = useRef(new KeywordRepository());
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      return keywordRepository.current.delete(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [KEYWORD_CACHE_KEYS.LIST, {}],
      });
    },
  });
};
